
/**
 * ZOHO PEOPLE IDENTITY PROVIDER SERVICE
 * Handles OAuth 2.0 handshake and profile sync with Miracle Air corporate directory.
 */

const API_BASE = import.meta.env.VITE_API_URL || '/meos/api';

/**
 * Initiates the Zoho People OAuth 2.0 Redirection
 */
export const initiateZohoSSO = () => {
  const authUrl = `${API_BASE}/auth/zoho`;
  window.location.href = authUrl;
};

/**
 * Simulates fetching the employee profile from Zoho People
 */
export const fetchZohoProfile = async (code: string) => {
  console.warn('fetchZohoProfile is not used; backend callback returns token directly');
  return null as any;
};

/**
 * Searches the Zoho People directory via backend
 */
export const searchZohoEmployees = async (query: string) => {
  const apiBase = import.meta.env.VITE_API_URL || '/meos/api';
  const url = `${apiBase}/auth/users/search-zoho?q=${encodeURIComponent(query)}`;
  const token = localStorage.getItem('ma_jwt');
  const res = await fetch(url, {
    credentials: 'include',
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  if (!res.ok) throw new Error(`Zoho search failed: ${res.status}`);
  const data = await res.json();
  // Map photoUrl from backend to avatar for frontend UI
  const mapped = (data.employees || []).map((emp: any) => ({
    ...emp,
    avatar: emp.photoUrl || '',
    dept: emp.base || 'N/A',
    name: emp.name || `${emp.firstName || ''} ${emp.lastName || ''}`.trim() || emp.email || 'Unknown'
  }));

  // Proxy photo URLs through backend to add OAuth auth header (via jwt query param)
  const jwt = localStorage.getItem('ma_jwt') || '';
  const proxied = mapped.map((emp: any) => {
    if (emp.avatar && emp.avatar.startsWith('http')) {
      emp.avatar = `${apiBase}/auth/zoho-photo?url=${encodeURIComponent(emp.avatar)}${jwt ? `&jwt=${encodeURIComponent(jwt)}` : ''}`;
    }
    return emp;
  });
  console.log('Search results mapped:', proxied);
  return proxied;
};
